import { ConfirmModal } from "../../../../components/ui";

/**
 * InspectorSentConfirmationModal Component
 *
 * Success confirmation modal after sending report to inspector.
 * Explains that inspector sees live data and report locks only after signature.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen - Whether modal is open
 * @param {Function} props.onClose - Callback to close modal
 * @param {string} props.inspectorEmail - Email address where report was sent
 * @param {string} props.copyEmail - Optional CC email address
 * @returns {JSX.Element}
 */
const InspectorSentConfirmationModal = ({
  isOpen,
  onClose,
  inspectorEmail,
  copyEmail,
}) => {
  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onClose}
      title="Report Sent to Inspector"
      buttonText="Continue"
      showCancel={false}
    >
      <div className="">
        {/* Success Message */}
        <div className="bg-green-50 border border-green-300 rounded p-4">
          <div className="text-center">
            <div>
              <p className="font-semibold text-green-800 mb-1">
                Email Sent Successfully
              </p>
              <p className="text-sm text-green-700">
                Inspector:{" "}
                <span className="font-semibold">{inspectorEmail}</span>
              </p>
              {copyEmail && (
                <p className="text-sm text-green-700 mt-1">
                  {copyEmail.includes(",") ? "CC Recipients:" : "CC:"}{" "}
                  <span className="font-semibold">{copyEmail}</span>
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </ConfirmModal>
  );
};

export default InspectorSentConfirmationModal;
